module.exports = __webpack_public_path__ + "img/Proofsheet - Blue - Selected.5eb78d49.png";